<form [formGroup]="formGroup" [bitSubmit]="submit" id="assign_collections_form">
  <p>
    {{
      (personalItemsCount === 1
        ? "bulkCollectionAssignmentDialogDescriptionSingular"
        : "bulkCollectionAssignmentDialogDescriptionPlural"
      ) | i18n
    }}
  </p>

  <ul class="tw-list-disc tw-pl-5 tw-space-y-2 tw-break-words">
    @if (readonlyItemCount > 0) {
      <li>
        0">
        <p>
          {{ "bulkCollectionAssignmentWarning" | i18n: totalItemCount : readonlyItemCount }}
        </p>
      </li>
    }
    @if (personalItemsCount > 0) {
      <li>
        0">
        <p>
          {{ transferWarningText(orgName, personalItemsCount) }}
        </p>
      </li>
    }
  </ul>

  @if (showOrgSelector) {
    <div class="tw-flex">
      <bit-form-field class="tw-grow tw-max-w-full">
        <bit-label>{{ "moveToOrganization" | i18n }}</bit-label>
        <bit-select formControlName="selectedOrg">
          @for (org of organizations$ | async; track org.id) {
            <bit-option icon="bwi-business" [value]="org.id" [label]="org.name"> </bit-option>
          }
        </bit-select>
      </bit-form-field>
    </div>
  }

  <div class="tw-flex">
    <bit-form-field class="tw-grow tw-max-w-full" disableMargin>
      <bit-label>{{ "selectCollectionsToAssign" | i18n }}</bit-label>
      <bit-multi-select
        class="tw-w-full"
        formControlName="collections"
        [baseItems]="availableCollections"
      ></bit-multi-select>
      @if (readOnlyCollectionNames.length > 0) {
        <bit-hint data-testid="view-only-hint">
          {{ "cannotRemoveViewOnlyCollections" | i18n: readOnlyCollectionNames.join(", ") }}
        </bit-hint>
      }
    </bit-form-field>
  </div>
</form>
